<template>
  <v-container v-if="loaded">
    <v-row>
      <v-form>
        <v-btn @click="loadInputFromJSON()" rounded block large>
          <v-icon  size="20" left color="green darken-3">cloud_upload</v-icon>
            {{ $t('mapeditor-load-json') }}
        </v-btn>
        
        <v-text-field id="w-input" type="number" @input="generateTiles()" min=4 :label="$t('width')" v-model="width_input"/>
        <v-text-field id="h-input" type="number" @input="generateTiles()" min=4 :label="$t('height')" v-model="height_input"/>
        <v-alert type=info>
          {{ $t('reset_warning') }}
        </v-alert>
        <div id="cb-copy" v-if="valid" v-on:click="copyToClipboard()">
          <v-alert type="success" transition=fade-transition>
          {{ $t('map_valid') }}
          </v-alert>
        </div>
          <v-alert v-else type="error">
            {{ errorMsg }}
          </v-alert>
      </v-form>
    </v-row>
    <v-row v-for="row in height" :key="`row-${row}`" >
      <span v-for="col in width" :key="`row-${row}-col-${col}`">
        <tile-editor :key="reload" :tile="getTile(col - 1, row - 1)"
                     @toggle-direction="toggleDirection(col - 1, row - 1, $event)"
                     @toggle-field-type="toggleFieldType(col - 1, row - 1, $event)"
                     :start="start"
                     :exits="exits" />
      </span>
    </v-row>
    <v-divider/>
    
    <!--<v-row>
      <v-btn v-if="map_loaded != undefined" @click="saveOutputToDatabase()" rounded  >
          <v-icon   left color="green darken-3">cloud_upload</v-icon>
            Save map "{{ map_loaded.name }}" to admin database
      </v-btn>
      <v-btn @click="saveNewMapToDatabase()" rounded >
          <v-icon  left color="green darken-3">cloud_upload</v-icon>
            Save as new map to admin database
      </v-btn>
    </v-row>
    <v-divider/>
    <v-row v-for="map in maps_from_db" :key="map.id">
      <v-btn  @click="loadInputFromDatabase(map.id)" rounded>
          <v-icon  left color="green darken-3">cloud_download</v-icon>
            Load map "{{ map.name }}" from admin database
        </v-btn>
    </v-row>  !-->
    <v-divider/>
    <v-row>
      <input ref="out" :value="output" />
    </v-row>
  </v-container>
</template>

<script>
import { Direction } from '../enums';
import TileEditor from './TileEditor.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'MapEditor',
  components: { TileEditor },
  data() {
    return {
      loaded: false,
      reload: 1337, // initial value does not matter
      input: '',
      json_input: 'Insert JSON here',
      width_input: 4,
      height_input: 4,
      width: 4,
      height: 4,
      boundary: {
        first: { second: 0, first: 0 },
        second: { second: 0, first: 0 },
      },
      exits: [],
      start: [],
      tiles: [],
      numberStart: 0,
      numberEnd: 0,
      name: '',
      loading: false,
      maps_from_db: [],
      map_loaded: undefined,
      lock: false,
    };
  },
  computed: {
    ...mapState('settings', ['DjangoServerAdress']),
    
    errorMsg() {
      if (this.exits.length <= 0) {
        return this.$t('map_invalid_exit');
      }
      if (this.start.length !== 1) {
        return this.$t('map_invalid_start');
      }
      if (this.height < 4) {
        return this.$t('map_invalid_height');
      }
      if (this.width < 4) {
        return this.$t('map_invalid_width');
      }
      return null;
    },
    valid() {
      return this.errorMsg == null;
    },
    output() {
      if (!this.valid) {
        return this.$t('map_invalid');
      }
      return JSON.stringify({
        tiles: this.tiles,
        exits: this.exits,
        start: this.start[0],
        boundary: this.boundary,
        name: this.name,
      });
    },
  },
  methods: {
    /**
     * Generate tiles
     */
    generateTiles() {
      this.tiles = [];
      this.start = [];
      this.exits = [];
      [...Array(this.width).keys()].forEach((x) => {
        [...Array(this.height).keys()].forEach((y) => {
          this.tiles.push([
            {
              first: x,
              second: y,
            },
            {
              directions: [],
            },
          ]);
        });
      });
      this.loaded = true;
      // this.reload is used above as the key to the tiles. Changing it forces Vue to re-render.
      this.reload += 1;
    },
    /**
     * Get tiles for coordinate
     * @param {Integer} x
     * @param {Integer} y
     */
    getTile(x, y) {
      return this.tiles.find(tile => tile[0].first === x && tile[0].second === y);
    },
    /**
     * Toggle if moving to direction is allowed in the tile
     * @param {Object} tile
     * @param {Direction} direction
     */
    toggleDirectionTile(tile, direction) {
      const index = tile[1].directions.indexOf(direction);

      if (index === -1) {
        tile[1].directions.push(direction);
      } else {
        tile[1].directions.splice(index, 1);
      }
    },
    /**
     * Handler for toggleDirection in TileEditor
     * @param {Integer} x
     * @param {Integer} y
     * @param {Direction} direction
     */
    toggleDirection(x, y, direction) {
      if (this.lock)
        return;

      this.lock=true;
      this.toggleDirectionTile(this.getTile(x, y), direction);
      if (direction === Direction.NORTH) {
        const tile = this.getTile(x, y - 1);
        if (tile) {
          this.toggleDirectionTile(tile, Direction.SOUTH);
        }
      }
      if (direction === Direction.SOUTH) {
        const tile = this.getTile(x, y + 1);
        if (tile) {
          this.toggleDirectionTile(tile, Direction.NORTH);
        }
      }
      if (direction === Direction.EAST) {
        const tile = this.getTile(x + 1, y);
        if (tile) {
          this.toggleDirectionTile(tile, Direction.WEST);
        }
      }
      if (direction === Direction.WEST) {
        const tile = this.getTile(x - 1, y);
        if (tile) {
          this.toggleDirectionTile(tile, Direction.EAST);
        }
      }
      this.lock=false;
    },
    toggleFieldType(x, y, { isStart, isEnd }) {
      if (this.lock)
        return;

      this.lock=true;
      if (isStart) {
        this.start.push({
          first: x,
          second: y,
        });
      } else {
        const start = this.start.find(field => field.first === x && field.second === y);
        if (start) {
          this.start.splice(this.start.indexOf(start));
        }
      }

      if (isEnd) {
        this.exits.push({
          first: x,
          second: y,
        });
      } else {
        const exit = this.exits.find(field => field.first === x && field.second === y);
        if (exit) {
          this.exits.splice(this.exits.indexOf(exit));
        }
      }
      this.lock=false;
    },
    parseJSON(json){
    if (json == null) {
        return false;
      }
      try {
        const parsed = JSON.parse(json);
        this.loading = true;
        if (!('start' in parsed)) {
          throw new Error('No start field defined!');
        }
        if (!('exits' in parsed)) {
          throw new Error('No exit fields defined!');
        }
        if (!('tiles' in parsed)) {
          throw new Error('No tiles defined!');
        }
        if (!('boundary' in parsed)) {
          throw new Error('No boundary defined!');
        }
        this.width_input = parsed.boundary.second.first + 1;
        this.height_input = parsed.boundary.second.second + 1;
        this.start = [parsed.start];
        this.exits = parsed.exits;

        this.tiles = parsed.tiles;
        this.reload += 1;
        this.loaded = true;
        this.boundary = parsed.boundary;

        setTimeout(() => { this.loading = false; }, 100);
        return true;
      } catch (e) {
        if (e instanceof SyntaxError) {
          alert(this.$t('mapeditor-input-syntaxerror'));
          console.log(e);
          return false;
        } else {
          alert(e);
          return false;
        }
      }
    },
    loadInputFromJSON() {
      const json = prompt(this.$t('mapeditor-insert-json'), '');
      var success = this.parseJSON(json);
      if (success) {
        this.map_loaded = undefined;
      }
    },
    loadInputFromDatabase(id){
      var xhr = new XMLHttpRequest();
      xhr.open("GET", this.DjangoServerAdress+"/api/maps/"+id+"?format=json", true);
      xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var parsed = JSON.parse(xhr.responseText);
          var success = this.parseJSON(parsed.json_map);
          if (success) {
            console.log("Success in loading map!", parsed)
            this.map_loaded = {};
            Object.assign(this.map_loaded, parsed);
          }
      } else {
        console.error("statustext:",xhr.statusText);
        }
      }
      }.bind(this);
      xhr.onerror = function (e) {
        console.error(xhr.statusText);
      };
      xhr.send(null); 
    },
    saveOutputToDatabase(){
      if (!this.valid){
        alert("Can't save map to admin interface: it is not valid :-(");
        return
      }
      var id = this.map_loaded.id;
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", this.DjangoServerAdress+"/api/maps/"+id+"/", true);
      xhr.setRequestHeader('Content-type','application/json');
      xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log("Map successfully stored to database.")
          alert("Map successfully updated")
      } else {
        console.error("statustext:",xhr);
        }
      }
      }.bind(this);
      xhr.onerror = function (e) {
        console.error(xhr.statusText);
      };
      var data = {};
      data.name = this.map_loaded.name;
      data.json_map = this.output;
      var json = JSON.stringify(data);
      xhr.send(json); 
    },
    saveNewMapToDatabase(){
      if (!this.valid){
        alert("Can't save map to admin interface: it is not valid :-(");
        return
      }
      var name = prompt('Please insert a map name.', '');
      if (!name){
        alert('Map was not saved to database.')
      }
      var xhr = new XMLHttpRequest();
      xhr.open("POST", this.DjangoServerAdress+"/api/maps/", true);
      xhr.setRequestHeader('Content-type','application/json');
      xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          alert("Map successfully updated")
          console.log("Map successfully stored to database.")
      } else {
        console.error("statustext:",xhr);
        }
      }
      }.bind(this);
      xhr.onerror = function (e) {
        console.error(xhr.statusText);
      };
      var data = {};
      data.name = name;
      data.json_map = this.output;
      var json = JSON.stringify(data);
      xhr.send(json); 
    },
    copyToClipboard() {
      const testingCodeToCopy = this.$refs.out;
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        if (!successful) {
          alert('Oops, unable to copy');
        }
      } catch (err) {
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },
  },
  watch: {
    width_input(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.width = parseInt(newValue, 10);
        this.boundary.second.first = this.width - 1;
        if (!this.loading) {
          this.generateTiles();
          this.map_loaded = undefined;
        }
      }
    },
    height_input(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.height = parseInt(newValue, 10);
        this.boundary.second.second = this.height - 1;
        if (!this.loading) {
          this.generateTiles();
          this.map_loaded = undefined;
        }
        
      }
    },
  },
  mounted() {
    this.boundary.second.second = this.height - 1;
    this.boundary.second.first = this.width - 1;
    this.generateTiles();
    var xhr = new XMLHttpRequest();
      xhr.open("GET", this.DjangoServerAdress+"/api/maps/?format=json", true);
      xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log("responsetext:",JSON.parse(xhr.responseText));
          this.maps_from_db = JSON.parse(xhr.responseText)
      } else {
        console.error("statustext:",xhr.statusText);
        }
      }
      }.bind(this);
      xhr.onerror = function (e) {
        console.error(xhr.statusText);
      };
      xhr.send(null); 
  },
};
</script>

<style scoped>

</style>
